import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = []
  static values = { 
    originalStatus: String,
    requiredCommentStatuses: Array,
    accountId: String,
    accountName: String
  }

  connect() {
    // Only set original status if this is a row controller (has select)
    const selectElement = this.element.querySelector('[data-admin--retainer-status-target="select"]')
    if (selectElement) {
      this.selectTarget = selectElement
      this.originalStatusValue = this.selectTarget.value
    }
    
    // Find form target
    const formElement = this.element.querySelector('[data-admin--retainer-status-target="form"]')
    if (formElement) {
      this.formTarget = formElement
    }
    
    // Find modal targets if they exist
    this.modalFormTarget = this.element.querySelector('[data-admin--retainer-status-target="modalForm"]')
    this.modalCommentTarget = this.element.querySelector('[data-admin--retainer-status-target="modalComment"]')
    this.modalCommentHiddenTarget = this.element.querySelector('[data-admin--retainer-status-target="modalCommentHidden"]')
    this.modalStatusTarget = this.element.querySelector('[data-admin--retainer-status-target="modalStatus"]')
    this.modalAccountIdTarget = this.element.querySelector('[data-admin--retainer-status-target="modalAccountId"]')
    this.modalStatusTextTarget = this.element.querySelector('[data-admin--retainer-status-target="modalStatusText"]')
    this.modalAccountNameTarget = this.element.querySelector('[data-admin--retainer-status-target="modalAccountName"]')

    if (this.element && this.element.classList.contains('status-updated')) {
      setTimeout(() => {
        this.element.classList.remove('status-updated')
      }, 1500)
    }
  }

  change(event) {
    const newValue = event.target.value
    const originalValue = this.originalStatusValue
    
    if (newValue === originalValue) return
    
    if (this.requiredCommentStatusesValue.includes(newValue)) {
      this.requestCommentForStatus(newValue)
    } else {
      this.submitForm(this.formTarget)
    }
  }

  requestCommentForStatus(newStatus) {
    // Find the shared modal on the page
    const modal = document.getElementById('shared-status-comment-modal')
    const modalController = this.application.getControllerForElementAndIdentifier(modal, 'admin--retainer-status')
    
    // Set up the modal form
    modalController.modalFormTarget.action = this.formTarget.action
    modalController.modalStatusTarget.value = newStatus
    modalController.modalAccountIdTarget.value = this.accountIdValue
    
    // Update display
    modalController.modalStatusTextTarget.textContent = newStatus
    modalController.modalAccountNameTarget.textContent = this.accountNameValue
    modalController.clearTrixEditor()
    
    const bootstrapModal = new bootstrap.Modal(modal)
    bootstrapModal.show()
  }

  submitModalForm(event) {
    event.preventDefault()
    
    // Get content from Trix editor
    const comment = this.modalCommentTarget.editor.getDocument().toString().trim()
    if (!comment) {
      this.modalCommentTarget.focus()
      this.modalCommentTarget.classList.add('is-invalid')
      return
    }

    this.submitForm(this.modalFormTarget)
  }

  clearTrixEditor() {
    if (this.modalCommentTarget && this.modalCommentTarget.editor) {
      this.modalCommentTarget.editor.loadHTML("")
      this.modalCommentTarget.classList.remove('is-invalid')
    }
  }

  disconnect() {
    // Clean up Trix editor when controller is removed
    if (this.modalCommentTarget && this.modalCommentTarget.editor) {
      this.modalCommentTarget.remove()
    }
  }

  cancelModal() {
    // Find the row controller that triggered this modal
    const accountId = this.modalAccountIdTarget.value
    const rowElement = document.querySelector(`[data-admin--retainer-status-account-id-value="${accountId}"]`)
    
    if (rowElement) {
      const rowController = this.application.getControllerForElementAndIdentifier(rowElement, 'admin--retainer-status')
      rowController.selectTarget.value = rowController.originalStatusValue
    }
    
    bootstrap.Modal.getInstance(this.element).hide()
  }

  async submitForm(formElement) {
    try {
      const response = await fetch(formElement.action, {
        method: 'PATCH',
        body: new FormData(formElement),
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'text/vnd.turbo-stream.html',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        }
      })
      
      if (response.ok) {
        // Update original value for the row that changed
        if (formElement === this.modalFormTarget) {
          // Modal submission - update the source row
          const accountId = this.modalAccountIdTarget.value
          const rowElement = document.querySelector(`[data-admin--retainer-status-account-id-value="${accountId}"]`)
          
          if (rowElement) {
            const rowController = this.application.getControllerForElementAndIdentifier(rowElement, 'admin--retainer-status')
            rowController.originalStatusValue = this.modalStatusTarget.value
            rowController.element.classList.remove('text-danger')
          }
          
          bootstrap.Modal.getInstance(this.element).hide()
        } else {
          // Regular row submission
          this.originalStatusValue = this.selectTarget.value
          this.element.classList.remove('text-danger')
        }
        
        const html = await response.text()
        Turbo.renderStreamMessage(html)
      } else {
        this.handleError()
      }
    } catch (error) {
      console.error('Error updating status:', error)
      this.handleError()
    }
  }

  clearValidation(event) {
    event.target.classList.remove('is-invalid')
  }

  handleError() {
    this.element.classList.add('text-danger')
    if (this.selectTarget) {
      this.selectTarget.value = this.originalStatusValue
    }
  }
}
